import { useMemo } from "react";
import ProfileScreen from "screens/profile";
import DashboardScreen from "screens/dashboard";
import ReportScreen from "screens/report";
import StatisticScreen from "screens/statistic";
import MonitoringScreen from "screens/monitoring";
import ReportAssignScreen from "screens/reportAssign";
import ReportAnalysisScreen from "screens/reportAnalysis";
import ReportIncidentScreen from "screens/reportIncident";
import SettingScreen from "screens/setting";
import SyntheticScreen from "screens/synthetic";
import ProjectManagementScreen from "screens/projectManagement";
import ProjectMemberManagementScreen from "screens/projectMemberManagement";
import ProjectMemberDetailScreen from "screens/projectMemberManagement/detail";
import ProjectOrganizationScreen from "screens/projectManagement/projectOrganization";
import UserScreen from "screens/user";
import DepartmentScreen from "screens/department";
import OrganizationScreen from "screens/organization";
import PushNotificationScreen from "screens/notification";



export const useMapScreenName = () => {
    let data: { [key: string]: JSX.Element } = useMemo(() => ({
        ProfileScreen: <ProfileScreen />,
        DashboardScreen: <DashboardScreen />,

        UserScreen: <UserScreen />,
        DepartmentScreen: <DepartmentScreen />,
        OrganizationScreen: <OrganizationScreen />,
        PushNotificationScreen: <PushNotificationScreen />,

        ReportScreen: <ReportScreen />,
        StatisticScreen: <StatisticScreen />,
        MonitoringScreen: <MonitoringScreen />,
        ReportAssignScreen: <ReportAssignScreen />,
        ReportAnalysisScreen: <ReportAnalysisScreen />,
        ReportIncidentScreen: <ReportIncidentScreen />,

        SettingScreen: <SettingScreen />,
        SyntheticScreen: <SyntheticScreen />,
        ProjectManagementScreen: <ProjectManagementScreen />,
        ProjectOrganizationScreen: <ProjectOrganizationScreen />,
        ProjectMemberDetailScreen: <ProjectMemberDetailScreen />,
        ProjectMemberManagementScreen: <ProjectMemberManagementScreen />,

    }), []);

    return data;
};
